import i18n from 'i18next';
import { FaTh, FaSquare } from '../../../../util/reactIcons';
import { languages } from '../../../../i18n';
import store from '../../../../store/store';
import { applyHangingProtocolById } from '../../../../protocols/hangingProtocolManager';
import { setLayoutGrid, setLayoutElements } from '../../../../actions/LayoutActions';

import {
  changeFullViews,
  displayAllSeries,
  displaySelectedSeries,
  displayGridModel,
 } from './LayoutUtils';

export const languageOptions = () => languages.map((language) => ({
  label: language.label,
  name: language.key,
  callback: () => i18n
    .changeLanguage(language.key)
    .then(() => sessionStorage.setItem('i18nextLng', language.key)),
  icon: null,
}));

// -------LAYOUTS------- DESCRIPTOR PARA LA UI
export const layoutOptions = () => {
  const layoutsObj = [
    {
      label: 'layouts.1x1',
      name: '1x1',
      callback: () => changeFullViews(),
      icon: FaSquare,
    },
    {
      label: 'layouts.selected',
      name: 'selected',
      callback: () => displaySelectedSeries(),
      icon: null,
    },
    {
      label: 'layouts.all',
      name: 'all',
      callback: () => displayAllSeries(),
      icon: FaTh,
    },
    {
      label: 'layouts.2x1',
      name: '2x1',
      callback: () => displayGridModel(2, 1),
      icon: null,
    },
    {
      label: 'layouts.3x1',
      name: '3x1',
      callback: () => displayGridModel(3, 1),
      icon: null,
    },
    {
      label: 'layouts.1x2',
      name: '1x2',
      callback: () => displayGridModel(1, 2),
      icon: null,
    },
    {
      label: 'layouts.2x2',
      name: '2x2',
      callback: () => displayGridModel(2, 2),
      icon: null,
    },
    {
      label: 'layouts.1x3',
      name: '1x3',
      callback: () => displayGridModel(1, 3),
      icon: null,
    },
    {
      label: 'layouts.2x3',
      name: '2x3',
      callback: () => displayGridModel(2, 3),
      icon: null,
    },
    {
      label: 'layouts.3x3',
      name: '3x3',
      callback: () => displayGridModel(3, 3),
      icon: null,
    },
  ];

  return layoutsObj;
};

export const layoutECGOptions = () => {
  const layoutsObj = [
    {
      label: 'layouts.1x1',
      name: '1x1',
      callback: () => changeFullViews(),
      icon: FaSquare,
    },
    {
      label: 'layouts.selected',
      name: 'selected',
      callback: () => displaySelectedSeries(),
      icon: null,
    },
    {
      label: 'layouts.2x1',
      name: '2x1',
      callback: () => displayGridModel(2, 1),
      icon: null,
    },
    {
      label: 'layouts.3x1',
      name: '3x1',
      callback: () => displayGridModel(3, 1),
      icon: null,
    },
  ];

  return layoutsObj;
};

export const hangingProtocolOptions = (protocols) => {
  const matchedProtocols = protocols || store.getState().protocols?.matchedProtocols || [];
  // Filter out any protocols that might not have a valid ID and map to options
  const options = matchedProtocols
    .filter((protocol) => protocol && protocol.id)
    .map((protocol) => ({
      label: protocol.name,
      name: protocol.id,
      icon: null,
      callback: () => {
        const patient = store.getState().patient;
        const result = applyHangingProtocolById(patient, protocol.id);

        if (result) {
          store.dispatch(setLayoutGrid(result.layout.columns, result.layout.rows));
          store.dispatch(setLayoutElements(result.elements));
        }
      }
  }));
  return options;
};
